import React from "react";
import styled from "styled-components";
import GoogleCalendarAuthButton from "./GoogleCalendar/GoogleCalendarAuthButton";
import OutlookCalendarAuthButton from "./OutlookCalendar/OutlookCalendarAuthButton";

const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
`;

interface CalendarSignInButtonRowProps {
    className?: string;
}
function CalendarSignInButtonRow(props: CalendarSignInButtonRowProps) {
    return (
        <ButtonContainer className={`calendar-signin-button-container ${props.className}`}>
            <GoogleCalendarAuthButton source={"widget"} />
            <OutlookCalendarAuthButton source={"widget"} />
        </ButtonContainer>
    );
}

export default CalendarSignInButtonRow;
